<template>
  <el-container class="damageOverflowList">
    <el-header class="box add bb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>库存管理</el-breadcrumb-item>
        <el-breadcrumb-item>报损报溢列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main class="p15 pt0">
      <div class="pt20" style="text-align: left">
        <el-form :inline="true" :model="query" class="demo-form-inline">
          <!-- 第一行筛选条件 - 使用flex布局 -->
          <div class="filter-row">
            <el-form-item>
              <el-input placeholder="商品编码" v-model="query.gtin" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                placeholder="商品名称"
                v-model="query.keyword"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                placeholder="批次号"
                v-model="query.batchNumber"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="query.type" placeholder="操作类型">
                <el-option label="报损" :value="0"></el-option>
                <el-option label="报溢" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- 第二行筛选条件 - 使用flex布局 -->
          <div class="filter-row">
            <el-form-item class="time-picker-item">
              <el-date-picker
                v-model="timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleTimeChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="button-group">
              <el-button type="primary" @click="onSubmit" size="middle"
                >查询</el-button
              >
              <el-button
                type="success"
                @click="handleDownloadTemplate"
                size="middle"
                >下载模板</el-button
              >
              <el-upload
                class="upload"
                action="#"
                :multiple="false"
                ref="upload"
                accept=".xlsx"
                :limit="1"
                :show-file-list="false"
                :before-upload="beforeUpload"
                style="float: right"
              >
                <el-button type="success" size="middle">批量导入</el-button>
              </el-upload>
              <!-- <el-upload
                action
                accept=".xlsx, .xls"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleImport"
                class="upload-btn"
              >
                <el-button type="success" size="middle">批量导入</el-button>
              </el-upload> -->
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="box list">
        <el-table border :data="tableData" style="width: 100%">
          <el-table-column
            type="index"
            align="center"
            width="60"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="gtin"
            min-width="120"
            :show-overflow-tooltip="true"
            label="商品编码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="batchNumber"
            min-width="120"
            :show-overflow-tooltip="true"
            label="批次号"
            align="center"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="商品名称"
            min-width="120"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="operationType"
            min-width="120"
            :show-overflow-tooltip="true"
            label="操作类型"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="!scope.row.type ? 'danger' : 'success'"
                effect="dark"
              >
                {{ scope.row.type ? "报溢" : "报损" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="reportedLoss"
            min-width="120"
            :show-overflow-tooltip="true"
            label="操作重量"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.reportedLoss">
                {{ scope.row.reportedLoss }}kg
              </span>
              <span v-else>
                {{
                  scope.row.reportedLossUnits
                    .map((v) => v.unitNum + v.unitName)
                    .join(" + ")
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="reportedLoss"
            min-width="120"
            :show-overflow-tooltip="true"
            label="操作前数量"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.reportedLossBefore">
                {{ scope.row.reportedLossBefore }}kg
              </span>
              <span v-else>
                {{
                  scope.row.reportedLossBeforeUnits
                    .map((v) => v.unitNum + v.unitName)
                    .join(" + ")
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="reportedLoss"
            min-width="120"
            :show-overflow-tooltip="true"
            label="操作后数量"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.afterTheDamage">
                {{ scope.row.afterTheDamage }}kg
              </span>
              <span v-else>
                {{
                  scope.row.afterTheDamageUnits
                    .map((v) => v.unitNum + v.unitName)
                    .join(" + ")
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operator"
            min-width="120"
            :show-overflow-tooltip="true"
            label="操作人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="operatorTime"
            min-width="150"
            :show-overflow-tooltip="true"
            label="操作时间"
            align="center"
          ></el-table-column>
        </el-table>
        <div class="i-page fr disib mt20">
          <el-pagination
            background
            :page-size="query.limit"
            layout="total,prev, pager, next"
            :total="total"
            :current-page="query.page"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
      <!-- reportedLoss: 20,reportedLossBefore: 39.1 -->
      <!-- 导入进度弹窗 -->
      <el-dialog
        :visible.sync="showProgress"
        :title="progressTitle"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :show-close="false"
      >
        <el-progress
          :text-inside="true"
          status="success"
          :stroke-width="30"
          :percentage="percentage"
        ></el-progress>
        <div v-if="errorData.length > 0" class="mt50">
          <div class="tc">
            <h3>以下记录导入失败</h3>
          </div>
          <el-table :data="errorData" border fit>
            <el-table-column
              property="gtin"
              label="商品编码"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              property="batchNumber"
              label="批次号"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              property="goodsName"
              label="商品名称"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              property="operationType"
              label="操作类型"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              property="operationQuantity"
              label="操作数量"
              min-width="150"
              align="center"
            ></el-table-column>
          </el-table>
          <div>共计{{ errorData.length }}条上传失败</div>
        </div>
        <div v-show="showProgressButton" class="tc mt50">
          <el-button type="primary" @click="showProgress = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import axios from "@/util/api";
import api from "@/util/extra-api";
import { local } from "@/util/util";
import * as XLSX from "xlsx/xlsx.mjs";

export default {
  name: "DamageOverflowList",
  data() {
    return {
      query: {
        page: 1,
        limit: 10,
        gtin: "",
        keyword: "",
        batchNumber: "",
        type: 0,
        startTime: "",
        endTime: "",
        companyId: "",
      },
      timeRange: [],
      tableData: [],
      total: 0,

      // 导入相关
      showProgress: false,
      showProgressButton: false,
      progressTitle: "上传中",
      percentage: 0,
      errorData: [],
      fileName: "",
      files: null,
    };
  },
  mounted() {
    // 初始化公司ID
    this.query.companyId = localStorage.getItem("company_id");
    this.init();
  },
  methods: {
    // 初始化数据
    init() {
      api.get("/v1/pc/stock/damagedList", this.query).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.total;
        }
      });
    },

    // 查询
    onSubmit() {
      this.query.page = 1;
      this.init();
    },

    // 时间选择变化
    handleTimeChange(value) {
      if (value && value.length === 2) {
        this.query.startTime = value[0];
        this.query.endTime = value[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
    },

    // 分页
    currentChange(page) {
      this.query.page = page;
      this.init();
    },

    // 下载模板
    handleDownloadTemplate() {
      // 下载导入模板
      axios
        .fileget("/pc/download/template", { fileName: "stockTemplate.xlsx" })
        .then((res) => {
          this.$message.success("模板下载成功");
        });
    },

    // 文件读取
    readFile(file) {
      return new Promise((resolve) => {
        let reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = (ev) => {
          resolve(ev.target.result);
        };
      });
    },

    // 导入处理
    beforeUpload(file) {
      this.files = file;
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension2) {
        this.$message.warning("上传模板只能是 xlsx格式!");
        return;
      }
      if (!isLt10M) {
        this.$message.warning("上传模板大小不能超过 10MB!");
        return;
      }
      this.fileName = file.name;
      setTimeout(() => {
        this.submitUpload();
      }, 500);
      return false; // 返回false不会自动上传
    },
    submitUpload() {
      if (this.fileName == "") {
        this.$message.warning("请选择要上传的文件！");
        return false;
      }
      let fileFormData = new FormData();
      fileFormData.append("file", this.files, this.fileName);
      //filename是键，file是值，就是要传的文件，test是要传的文件名
      fileFormData.append("companyId", this.query.companyId);

      // 执行上传excel
      let id = "";
      api
        .uploadFile("/v1/pc/stock/importExcel", fileFormData)
        .then((resp) => {
          if (resp.code != 200) {
            this.$message.error("excel上传失败，请重新上传");
          } else {
            this.query.page = 1;
            this.init();
          }
        })
        .catch((e) => {
          //console.debug(e);
          this.$message.error("excel上传失败，请重新上传");
        });
    },
    // async handleImport(ev) {
    //   let _this = this;
    //   let file = ev.raw;
    //   if (!file) {
    //     return;
    //   } else {
    //     _this.showProgress = true;
    //     _this.showProgressButton = false;
    //     _this.percentage = 0;
    //     _this.errorData = [];

    //     try {
    //       let data = await this.readFile(file);
    //       let workbook = XLSX.read(data, { type: "binary" });
    //       let worksheet = workbook.Sheets[workbook.SheetNames[0]];
    //       let result = XLSX.utils.sheet_to_json(worksheet);

    //       let l = result.length;
    //       let successCount = 0;

    //       // 批量导入接口
    //       for (let item of result) {
    //         // 添加公司ID到导入数据
    //         item.companyId = this.query.companyId;

    //         // 调用导入接口
    //         let res = await api.post("/v1/pc/stock/importDamaged", item);
    //         if (res.code === 200) {
    //           successCount++;
    //         } else {
    //           _this.errorData.push(item);
    //         }

    //         _this.percentage = ((successCount / l) * 100).toFixed(1);
    //       }

    //       _this.progressTitle = "上传完成";
    //       _this.showProgressButton = true;

    //       // 重新加载列表
    //       _this.init();
    //     } catch (error) {
    //       _this.$message.error("文件导入失败: " + error.message);
    //       _this.showProgress = false;
    //     }
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.damageOverflowList {
  overflow-x: hidden;
  .add {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

// 筛选行布局
.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  .el-form-item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  // 时间选择器特殊宽度
  .time-picker-item {
    margin-right: 20px;
  }

  // 按钮组特殊样式
  .button-group {
    display: flex;
    align-items: center;

    .el-button {
      margin-right: 10px;
    }

    .upload-btn {
      display: inline-block;
    }
  }
}

// 调整表单布局
.demo-form-inline {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>